export default __webpack_public_path__ + "static/media/img5.d35c367d.jpg";